module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wang-editor"
  }, [_c('div', {
    staticClass: "wangEditor-txt",
    attrs: {
      "id": _vm.domId
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowPreviewBox),
      expression: "isShowPreviewBox"
    }],
    staticClass: "editor-preview question-content markdown-body"
  }, [_c('div', {
    staticClass: "question-desc",
    domProps: {
      "innerHTML": _vm._s(_vm.editorValue)
    }
  })]), _vm._v(" "), (_vm.isShowTips) ? _c('p', {
    staticClass: "fullScreen-tips"
  }, [_vm._v("\n        按"), _c('span', [_vm._v("ESC")]), _vm._v("键 可以快速退出全屏\n    ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-42e73332!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/community/wangEditor.vue
// module id = dBPI
// module chunks = 15